<template>
    <div>
        <h1>Test</h1>
        <p>Test</p>
    </div>
</template>

<script lang="ts" setup></script>
